import React, { useContext, useEffect } from "react";

import AppContext from "../../../context/AppContext";
import { SIDER_TABS } from "../../../utils/Constants";
import { AppStrings } from "../../../utils/constants/AppStrings";
import { usePageTitle } from "../../CommonComponents/Layout/PageTitleContext";

import styles from "./Configuration.module.css";

type PredictionsAppContext = {
  setActiveSidebarTab: (tab: string, option?: string) => void;
};

const Configuration: React.FC = () => {
  usePageTitle(AppStrings.CONFIGURATION);

  const { setActiveSidebarTab } = useContext(
    AppContext,
  ) as PredictionsAppContext;

  useEffect(() => {
    setActiveSidebarTab(SIDER_TABS.PREDICTIONS, "CONFIGURATION");
  }, [setActiveSidebarTab]);

  return (
    <div className={styles.page} />
  );
};

export default Configuration;
